<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <v-card
    class="pa-4 px-6 mt-8"
    height="fit-content"
    outlined
  >
    <div>
      <div class="text-h4 font-weight-medium">
        {{ $t('option') }}
      </div>
      <div
        v-if="currentSelectedList.length===0"
        class="text-body-2 mt-8"
      >
        //如果需要为商品添加选项，例如，添加温度，糖度，Topping等，请点击下方的添加选项按钮
        {{
          $t('append_new_option_click_button_below')
        }}
      </div>
    </div>
    <v-divider class="my-4"/>
    <div>
      <attribute-card
        v-for="ag in currentSelectedList"
        :key="ag.id"
        :ag="ag"
        :current-dish-id="dishesId"
        :in-edit="currentEditAGId===ag.id"
        :selected-a-id-list="selectedAIdList"
        @edit="currentEditAGId=ag.id"
        @remove-ag="toggleAttributeGroup"
        @edit-finished="afterAttributeCardSave"
        @click-checkbox="toggleAttributeActive"
      />
    </div>


    <div
      class="d-flex align-center pb-4 primary--text"
      @click="startAddGroup"
    >
      <v-icon
        class="mr-4"
        color="primary"
      >
        mdi-plus
      </v-icon>
      <div v-if="currentSelectedList.length>0">
        {{ $t('add_other_select_sort') }}
      </div>
      <div v-else>
        {{ $t('newAddEmpty') }}
      </div>
    </div>
    <v-dialog
      v-model="showAddAGDialog"
      max-width="600px"
    >
      <v-card class="pa-4">
        <div class="d-flex align-center">
          <div class="text-h4 font-weight-bold">
            {{ $t('add_new_select_sort') }}
          </div>
          <v-spacer/>
          <v-btn
            :color="showHelpText?'success':''"
            height="36px"
            icon
            width="36px"
            @click="showHelpText=!showHelpText"
          >
            <v-icon size="24">
              mdi-help-box
            </v-icon>
          </v-btn>
        </div>

        <v-divider class="my-4"/>
        <div>
          <div>
            <template v-if="!selectIsFinish">
              <div class="text-body-2">
                {{ $t('select_sort') }}<br>
              </div>
              <div
                v-if="showHelpText"
                class="text-caption"
              >
                {{
                  $t('select_sort_ist_select_group_e.g_sugar_has_three_selections_pls_enter_select_sort_name_first')
                }}
              </div>

              <v-autocomplete
                :items="currentNotSelectedList"
                :placeholder="$t('newAdd')"
                :search-input.sync="editAG.name"
                auto-select-first
                autofocus
                class="mt-1"
                dense
                hide-details
                item-text="name"
                outlined
                return-object
                @change="oldSelected"
              >
                <template #no-data>
                  <v-list-item @click="createNewSelected">
                    <v-list-item-content>
                      <v-list-item-title>
                        {{ $t('click_here_to_create_a_new_select_sort') }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </template>
          </div>

          <template v-if="selectIsFinish">
            <template v-if="selectedAddNew">
              <div class="text-body-2 font-weight-bold">
                {{ $t('select_sort') }}
              </div>
              <div
                v-if="showHelpText"
                class="text-caption"
              >
                {{
                  $t('select_sort_ist_select_group_e.g_sugar_has_three_selections_pls_enter_select_sort_name_first')
                }}
              </div>
              <v-text-field
                v-model="editAG.name"
                class="mt-2"
                dense
                hide-details
                outlined
              />
              <div class="ml-n4 mt-2">
                <v-checkbox
                  v-model="editAG.required"
                  :label="$t('required_one_option_must_be_selected')"
                  dense
                  hide-details
                />
                <div
                  v-if="showHelpText"
                  class="text-caption ml-12"
                >
                  {{ $t('e.g_ice_surge_must_be_selected_some_others_topping_is_not_neccessary') }}
                </div>
                <v-checkbox
                  v-model="editAG.multiple"
                  :label="$t('多选，可以选择多个选项')"
                  dense
                  hide-details
                />
                <div
                  v-if="showHelpText"
                  class="text-caption ml-12"
                >
                  {{
                    $t('e.g_add_ingrendients_topping_cound_be_added_multiple_ice_sugar_size_can_be_selected_just_one')
                  }}
                </div>
              </div>

              <v-divider class="my-4"/>
              <template v-if="addedAttributes.length>0">
                <div class="mb-1">
                  <div class="text-body-2 mt-4 font-weight-bold">
                    {{ $t('chooseList') }}
                  </div>
                  <div
                    v-if="showHelpText"
                    class="text-caption"
                  >
                    {{ $t('if_it_needs_to_adjust_tax_rate_pictures_should_edit_in_details') }}
                  </div>
                </div>

                <div
                  v-for="(a,index) in addedAttributes"
                  :key="a.key"
                  class="d-flex align-center mb-1"
                >
                  <v-text-field
                    v-model="a.name"
                    :placeholder="$t('newAdd')"
                    dense
                    hide-details
                    outlined
                  />
                  <div style="width: 16px"/>
                  <div style="width: 120px">
                    <v-text-field
                      v-model="a.price"
                      append-icon="mdi-cash"
                      dense
                      hide-details
                      outlined
                      placeholder="0.00"

                      step="0.5"
                      type="number"
                    />
                  </div>

                  <div style="width: 60px">
                    <v-btn
                      :disabled="addedAttributes.length===1||(!a.price&&!a.name)"
                      class="ml-1"
                      icon
                      @click="addedAttributes.splice(index,1)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </div>
              </template>
            </template>
            <template v-else>
              <div v-if="selectedAG">
                <div class="text-body-1 font-weight-bold ">
                  {{ $t('select_sort_which_should_be_added') }}
                </div>
                <div class="text-caption">
                  {{ $t('after_addition_you_can_adjust_the_position_and_availability') }}
                </div>
                <div class="text-body-1 font-weight-medium mt-4">
                  {{ selectedAG.name }}
                </div>
                <div class="d-flex mt-4 flex-wrap">
                  <div
                    v-for="a in selectedAG.attributes"
                    :key="a.id"
                  >
                    <v-chip
                      class="pa-2 mb-2 mr-2"
                      style="height: 24px"
                    >
                      {{ a.name }}
                    </v-chip>
                  </div>
                </div>
              </div>
            </template>
            <v-divider class="my-4"/>
            <v-btn
              class="mr-2"
              outlined
              @click="startAddGroup"
            >
              <v-icon left>
                mdi-arrow-left
              </v-icon>
              {{ $t('return') }}
            </v-btn>
            <v-btn
              v-if="selectIsFinish"
              :disabled="!(!selectedAddNew||needToAdd.length>0)"
              color="primary"
              elevation="0"
              @click="saveAndReload"
            >
              {{ $t('add') }}
              <v-icon right>
                mdi-check
              </v-icon>
            </v-btn>
          </template>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
  import AttributeCard from '@/views/AadenPages/dishes/dish/detail/fragments/widget/AttributeCard'
  import Attribute from '@/model/dish/Attribute'
  import { groupBy } from 'lodash-es'
  import AttributeGroup from '@/model/dish/AttributeGroup'
  import { checkDishDetail, flipAttributes, toggleAttributeGroup } from '@/common/common'
  import IKUtils from 'innerken-js-utils'

  let counter = 0
  const defaultAttributeGroup = {
    name: '',
    required: true,
    multiple: false,
  }

  const defaultAttribute = {
    name: '',
    price: '',
  }
  console.log(defaultAttribute)

  export default {
    name: 'AttributeEditFragment',
    components: {
      AttributeCard,
    },
    props: {
      dishesId: {},
    },
    data () {
      return {
        attributeGroupList: [],
        addedAttributes: [this.createDefaultAttribute()],
        newAddedAttributeGroupList: [],
        selectedAGIdList: [],
        selectedAIdList: [],
        loading: false,

        Attribute,
        currentEditAGId: null,
        editAG: this.createDefaultAG(),

        showAddAGDialog: null,
        selectIsFinish: false,
        selectedAddNew: false,
        showHelpText: true,
        selectedAG: null,
      }
    },
    computed: {
      currentSelectedList () {
        return this.attributeGroupList
          .filter(it => this.selectedAGIdList.includes(it.id.toString()))
      },
      currentNotSelectedList () {
        return this.attributeGroupList
          .filter(it => !this.selectedAGIdList.includes(it.id.toString()))
      },
      needToAdd () {
        return this.addedAttributes.filter(it => it.name)
      },
    },
    watch: {
      dishesId: {
        immediate: true,
        handler () {
          this.initial()
        },
      },
      addedAttributes: {
        deep: true,
        handler (val) {
          const emptyNode = val.filter(it => !it.name && !it.price).length
          if (emptyNode === 0) {
            this.addedAttributes.push(this.createDefaultAttribute())
          }
        },
      },
    },
    async mounted () {
      await this.initial()
    },
    methods: {
      async saveAndReload () {
        IKUtils.showLoading()
        if (this.selectedAddNew) {
          this.editAG.required = this.editAG.required ? 1 : 0
          this.editAG.multiSelect = this.editAG.multiple ? 1 : 0
          this.editAG.printTitle = this.editAG.name
          const agId = (await AttributeGroup.add(this.editAG)).id
          let counter = 1
          for (const a of this.needToAdd) {
            a.attributeGroupId = agId
            a.printMod = a.name
            a.value = counter++

            a.priceMod = a.price || 0
            a.dishesCategoryTypeId = 9
            a.isActive = 1
            await Attribute.add(a)
          }
          await this.toggleAttributeGroup(agId)
        } else {
          await this.toggleAttributeGroup(this.selectedAG.id)
        }
        this.showAddAGDialog = false
        IKUtils.toast(this.$t('addSuccess!'))
      },
      startAddGroup () {
        this.editAG = this.createDefaultAG()
        this.selectedAG = null
        this.selectIsFinish = false
        this.selectedAddNew = false
        this.showAddAGDialog = true
        this.addedAttributes = []
      },
      createDefaultAG () {
        const obj = IKUtils.deepCopy(defaultAttributeGroup)
        obj.key = counter++
        return obj
      },
      oldSelected (event) {
        this.selectedAG = event
        this.selectIsFinish = true
        this.selectedAddNew = false
        console.log(event)
      },
      createNewSelected () {
        this.selectedAddNew = true
        this.selectIsFinish = true
        this.addedAttributes = [this.createDefaultAttribute()]
      },
      createDefaultAttribute () {
        const obj = IKUtils.deepCopy(defaultAttribute)
        obj.key = counter++
        return obj
      },
      async initial () {
        await this.wait(async () => {
          await this.reloadModInfo()
        })
      },
      async afterAttributeCardSave () {
        this.currentEditAGId = null

        await this.reloadModInfo()
      },

      async reloadAttributeList () {
        const dict = groupBy(await Attribute.getList(true), 'attributeGroupId')
        this.attributeGroupList = (await AttributeGroup.getList(true)).map(it => {
          it.attributes = dict[it.id]
          return it
        })
      },

      async getModDetail () {
        const res = await checkDishDetail(this.dishesId)
        const formattedModInfo = res.modInfo?.map(it => {
          return {
            id: it.id,
            aId: it.selectValue?.split(',') ?? [],
          }
        }) ?? []
        const agList = formattedModInfo.map(it => it.id)
        const aList = formattedModInfo.map(it => it.aId).flat()
        return [agList, aList]
      },
      async reloadModInfo () {
        await this.reloadAttributeList();
        [this.selectedAGIdList, this.selectedAIdList] = await this.getModDetail(this.dishesId)
        console.log(this.selectedAIdList)
        this.$emit('update-mod-list', this.selectedAGIdList)
      },

      async afterEdit () {
        this.loading = false
      },

      async toggleAttributeGroup (agId) {
        this.loading = true
        this.currentEditAGId = null
        await toggleAttributeGroup(agId, this.dishesId)
        await this.reloadModInfo()
        await this.afterEdit()
      },

      async toggleAttributeActive (aId, agId) {
        await flipAttributes(this.dishesId, agId, aId)
        await this.reloadModInfo()
        await this.afterEdit()
      },

      async wait (action) {
        this.loading = true
        try {
          await action()
        } catch (e) {

        }
        this.loading = false
      },

      close () {
        this.$router.back()
      },
    }
    ,
  }
</script>

<style scoped>

</style>
